import Vue from 'vue'
import { QUOTE_CARGO_PARAM, QUOTE_CARGO_PARAM_GENERAL, QUOTE_CARGO_GENERAL_SIDECLARED, QUOTE_CARGO_GENERAL_LOADMASTER, QUOTE_CARGO_GENERAL, QUOTE_CARGO_SHIPMENT, QUOTE_CARGO_PARAM_VESSEL, QUOTE_CARGO_PARAM_SHIPMENT, QUOTE_CARGO_CLAUSE, QUOTE_CARGO_DEFCLAUSE, QUOTE_CARGO_PARAM_CLAUSE, QUOTE_CARGO_PARAM_DEFCLAUSE, QUOTE_CARGO_PARAM_DEFCLAUSE_LOADING, QUOTE_CARGO_PARAM_DEFCLAUSE_FAIL, QUOTE_CARGO_INSURED, QUOTE_CARGO_PARAM_INSURED, QUOTE_CARGO_PREMIUM, QUOTE_CARGO_PREMIUM_MANUALRATE } from '@/store/types'
import { removeFormatNumber } from '@/utils/number'
import clone from 'clone'
import { extractRecord } from '@/utils/extract'

export const cargo = {
  [QUOTE_CARGO_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.quotation.cargoParam, key, arr)
          }
        }
      })
      // Object.assign(state.quotation.cargoParam, formatData)
    }
  },
  [QUOTE_CARGO_PARAM_GENERAL](state) {
    state.quotation.cargoParam.generalLoaded = true
  },
  [QUOTE_CARGO_PARAM_SHIPMENT](state, data) {
    // Pass data in instead of defaulting is because we might need a param reload
    state.quotation.cargoParam.shipmentLoaded = data
  },
  [QUOTE_CARGO_PARAM_CLAUSE](state, data) {
    // Pass data in instead of defaulting is because we might need a param reload
    state.quotation.cargoParam.clausesLoaded = data
  },
  [QUOTE_CARGO_PARAM_INSURED](state, data) {
    // Pass data in instead of defaulting is because we might need a param reload
    state.quotation.cargoParam.insuredLoaded = data
  },
  [QUOTE_CARGO_GENERAL_SIDECLARED](state, data) {
    if (data) {
      state.quotation.cargoForm.siDeclared = data.siDeclared
      state.quotation.cargoForm.siBalance = data.siBalance
    } else {
      state.quotation.cargoForm.siDeclared = undefined
      state.quotation.cargoForm.siBalance = undefined
    }
  },
  [QUOTE_CARGO_GENERAL](state, data) {
    if (data) {
      state.quotation.commonForm.product = data.product
      state.quotation.cargoForm.busCls = data.busCls
      state.quotation.commonForm.acceptDate = data.acceptDate
      state.quotation.commonForm.startDate = data.startDate
      state.quotation.commonForm.endDate = data.endDate
      state.quotation.cargoForm.tariff = data.tariff
      state.quotation.cargoForm.comdty = data.comdty
      state.quotation.cargoForm.pack = data.pack
      if (data.si) {
        state.quotation.cargoForm.si = removeFormatNumber(data.si)
      }
      if (data.siBalance) {
        state.quotation.cargoForm.siBalance = removeFormatNumber(data.siBalance)
      }
      if (data.siDeclared) {
        state.quotation.cargoForm.siDeclared = removeFormatNumber(data.siDeclared)
      }
      state.quotation.cargoForm.printSi = data.printSi
      state.quotation.cargoForm.tolerance = data.tolerance
      state.quotation.cargoForm.siUplift = data.siUplift
      state.quotation.cargoForm.siCurr = data.siCurr
      // Resolve currency rate from currency
      if (data.siCurr !== null && state.quotation.cargoParam.currRates && state.quotation.cargoParam.currRates.length > 0) {
        const currRateRecord = extractRecord(state.quotation.cargoParam.currRates, data.siCurr)
        Object.assign(data, {
          siCurrRate: currRateRecord.secondaryValue
        })
      }
      state.quotation.cargoForm.siCurrRate = data.siCurrRate
      state.quotation.commonForm.billCurr = data.billCurr
      // Resolve currency rate from currency
      if (data.billCurr !== null && state.quotation.cargoParam.currRates && state.quotation.cargoParam.currRates.length > 0) {
        const currRateRecord = extractRecord(state.quotation.cargoParam.currRates, data.billCurr)
        Object.assign(data, {
          billCurrRate: currRateRecord.secondaryValue
        })
      }
      state.quotation.commonForm.billCurrRate = data.billCurrRate
      state.quotation.cargoForm.subjectMatter = data.subjectMatter
      state.quotation.commonForm.quotationType = data.quotationType
      state.quotation.commonForm.masterProposalNo = data.masterProposalNo
      state.quotation.commonForm.campaign = data.campaign
      state.quotation.commonForm.promotion = data.promotion
    }
  },
  [QUOTE_CARGO_SHIPMENT](state, data) {
    if (data) {
      state.quotation.cargoForm.convy = data.convy
      state.quotation.cargoForm.lcNo = data.lcNo
      state.quotation.cargoForm.vesNo = data.vesNo
      state.quotation.cargoForm.voyNo = data.voyNo
      state.quotation.cargoForm.voyDateType = data.voyDateType
      state.quotation.cargoForm.voyDate = data.voyDate
      state.quotation.cargoForm.voyArea = data.voyArea
      state.quotation.cargoForm.portFrom = data.portFrom
      state.quotation.cargoForm.portTo = data.portTo
      state.quotation.cargoForm.voyDesc = data.voyDesc
      state.quotation.cargoForm.surveyAgt = data.surveyAgt
      state.quotation.cargoForm.settlingAgt = data.settlingAgt
      state.quotation.cargoForm.clmPayAt = data.clmPayAt
      state.quotation.cargoForm.csgnName = data.csgnName
      state.quotation.cargoForm.csgnAdd1 = data.csgnAdd1
      state.quotation.cargoForm.csgnAdd2 = data.csgnAdd2
      state.quotation.cargoForm.csgnAdd3 = data.csgnAdd3
      state.quotation.cargoForm.csgnAdd4 = data.csgnAdd4
    }
  },
  [QUOTE_CARGO_PARAM_VESSEL](state, data) {
    if (data.data && data.data.length > 0) {
      // Make it so that its value - label (easier to search)
      data.data.map(obj => {
        obj.label = obj.value + ' - ' + obj.label
      })
    }
    state.quotation.cargoParam.vessel.data = data.data
    state.quotation.cargoParam.vessel.menu = data.menu
  },
  [QUOTE_CARGO_PARAM_DEFCLAUSE_LOADING](state) {
    state.quotation.cargoParam.clauseInit = 0
  },
  [QUOTE_CARGO_PARAM_DEFCLAUSE](state, data) {
    state.quotation.cargoParam.clause = clone(data)
    state.quotation.cargoParam.clauseInit = 1
  },
  [QUOTE_CARGO_PARAM_DEFCLAUSE_FAIL](state) {
    state.quotation.cargoParam.clauseInit = 2
  },
  [QUOTE_CARGO_DEFCLAUSE](state, data) {
    if (data) {
      state.quotation.cargoForm.clause = clone(data)
    }
  },
  [QUOTE_CARGO_CLAUSE](state, data) {
    if (data) {
      state.quotation.cargoForm.cover = data.cover
      state.quotation.cargoForm.clause = clone(data.clause)
    }
  },
  [QUOTE_CARGO_INSURED](state, data) {
    if (data) {
      const { applicant } = state.quotation.commonForm

      applicant.appIntStat = data.applicant.appIntStat
      applicant.appName = data.applicant.appName
      applicant.appNricPassport = data.applicant.appNricPassport
      applicant.appOccupation = data.applicant.appOccupation
      applicant.appEmail = data.applicant.appEmail
      applicant.appMobileNo = data.applicant.appMobileNo
      applicant.appTelNo1 = data.applicant.appTelNo1
      applicant.appTelNo2 = data.applicant.appTelNo2
      applicant.appFaxNo = data.applicant.appFaxNo
      applicant.appPostalCode = data.applicant.appPostalCode
      applicant.appAdd1 = data.applicant.appAdd1
      applicant.appAdd2 = data.applicant.appAdd2
      applicant.appAdd3 = data.applicant.appAdd3
      applicant.appAdd4 = data.applicant.appAdd4
      applicant.appState = data.applicant.appState
      applicant.appCountry = data.applicant.appCountry
      applicant.mailAdd = data.applicant.mailAdd
      applicant.mailPostalCode = data.applicant.mailPostalCode
      applicant.mailAdd1 = data.applicant.mailAdd1
      applicant.mailAdd2 = data.applicant.mailAdd2
      applicant.mailAdd3 = data.applicant.mailAdd3
      applicant.mailAdd4 = data.applicant.mailAdd4
      applicant.mailState = data.applicant.mailState
      applicant.mailCountry = data.applicant.mailCountry
      applicant.coyName = data.applicant.coyName
      applicant.coyName2 = data.applicant.coyName2
      applicant.coyRocUen = data.applicant.coyRocUen
      applicant.coyNature = data.applicant.coyNature

      state.quotation.commonForm.finInst = data.finInst
      state.quotation.cargoForm.finInstDesc = data.finInstDesc
      state.quotation.cargoForm.finInstDesc2 = data.finInstDesc2
    }
  },
  [QUOTE_CARGO_PREMIUM_MANUALRATE](state, data) {
    const manualRateData = clone(data)
    if (manualRateData && manualRateData.length > 0) {
      for (let manualRate of manualRateData) {
        manualRate.value = removeFormatNumber(manualRate.value)
      }
    }
    state.quotation.cargoForm.manualRate = clone(manualRateData)
  },
  [QUOTE_CARGO_PREMIUM](state, data) {
    if (data) {
      const manualRateData = clone(data.manualRate)
      if (manualRateData && manualRateData.length > 0) {
        for (let manualRate of manualRateData) {
          manualRate.value = removeFormatNumber(manualRate.value)
        }
      }
      state.quotation.cargoForm.manualRate = clone(manualRateData)
      state.quotation.cargoForm.siDeclared = data.siDeclared
      state.quotation.cargoForm.benefits = clone(data.benefits)
    }
  },
  [QUOTE_CARGO_GENERAL_LOADMASTER](state, data) {
    if (data) {
      // Proposal Level
      commitProposal(state, data)

      // Risk Specifics
      commitCargo(state, data)
    }
  }
}

const commitProposal = (state, data) => {
  const { commonForm } = state.quotation

  commonForm.finInst = data.finInst
  commonForm.product = data.product
  commonForm.billCurr = data.billCurr
  commonForm.billCurrRate = data.billCurrRate

  commonForm.applicant.appIntStat = data.appIntStat
  commonForm.applicant.appName = data.appName
  commonForm.applicant.appNricPassport = data.appNricPassport
  commonForm.applicant.appOccupation = data.appOccupation
  commonForm.applicant.appEmail = data.appEmail
  commonForm.applicant.appMobileNo = data.appMobileNo
  commonForm.applicant.appTelNo1 = data.appTelNo1
  commonForm.applicant.appTelNo2 = data.appTelNo2
  commonForm.applicant.appFaxNo = data.appFaxNo
  commonForm.applicant.appPostalCode = data.appPostalCode
  commonForm.applicant.appAdd1 = data.appAdd1
  commonForm.applicant.appAdd2 = data.appAdd2
  commonForm.applicant.appAdd3 = data.appAdd3
  commonForm.applicant.appAdd4 = data.appAdd4
  commonForm.applicant.appState = data.appState
  commonForm.applicant.appCountry = data.appCountry
  commonForm.applicant.mailAdd = data.mailAdd
  commonForm.applicant.mailPostalCode = data.mailPostalCode
  commonForm.applicant.mailAdd1 = data.mailAdd1
  commonForm.applicant.mailAdd2 = data.mailAdd2
  commonForm.applicant.mailAdd3 = data.mailAdd3
  commonForm.applicant.mailAdd4 = data.mailAdd4
  commonForm.applicant.mailState = data.mailState
  commonForm.applicant.mailCountry = data.mailCountry
  commonForm.applicant.coyName = data.coyName
  commonForm.applicant.coyRocUen = data.coyRocUen
  commonForm.applicant.coyNature = data.coyNature
  commonForm.applicant.appIsDrv = data.appIsDrv

  commonForm.masterProposalNo = data.proposalNo
}

const commitCargo = (state, data) => {
  const { cargoForm } = state.quotation
  let cargo = data.cargo
  if (!cargo || cargo === null) {
    cargo = {}
  }

  cargoForm.busCls = cargo.busCls
  cargoForm.tariff = cargo.tariff
  cargoForm.comdty = cargo.comdty
  cargoForm.pack = cargo.pack
  cargoForm.siBalance = cargo.siBalance
  cargoForm.printSi = cargo.printSi
  cargoForm.siCurr = cargo.siCurr
  cargoForm.siCurrRate = cargo.siCurrRate
  cargoForm.tolerance = cargo.tolerance
  cargoForm.siUplift = cargo.siUplift
  cargoForm.subjectMatter = cargo.subjectMatter
  cargoForm.convy = cargo.convy
  cargoForm.vesNo = cargo.vesNo
  cargoForm.voyNo = cargo.voyNo
  cargoForm.voyDateType = cargo.voyDateType
  cargoForm.voyDate = cargo.voyDate
  cargoForm.voyArea = cargo.voyArea
  cargoForm.portFrom = cargo.portFrom
  cargoForm.portTo = cargo.portTo
  cargoForm.voyDesc = cargo.voyDesc
  cargoForm.lcNo = cargo.lcNo
  cargoForm.csgnName = cargo.csgnName
  cargoForm.surveyAgt = cargo.surveyAgt
  cargoForm.settlingAgt = cargo.settlingAgt
  cargoForm.clmPayAt = cargo.clmPayAt
  cargoForm.csgnName = cargo.csgnName
  cargoForm.csgnAdd1 = cargo.csgnAdd1
  cargoForm.csgnAdd2 = cargo.csgnAdd2
  cargoForm.csgnAdd3 = cargo.csgnAdd3
  cargoForm.csgnAdd4 = cargo.csgnAdd4
  cargoForm.cover = cargo.cover

  // Clause
  if (cargo.clause && cargo.clause.length > 0) {
    cargoForm.clause = cargo.clause
  } else {
    cargoForm.clause = []
  }
}
